<template>
  <MaterialButton 
    @click="handleGoBack" 
    :color="color" 
    :variant="variant"
    :size="size"
    :type="type"
    :class="customClass"
  >
    <i class="material-icons me-2">arrow_back</i>
    {{ label }}
  </MaterialButton>
</template>

<script setup>
import { useRouter } from "vue-router";
import MaterialButton from "@/components/common/MaterialButton.vue";

const props = defineProps({
  label: {
    type: String,
    default: "Go Back"
  },
  color: {
    type: String,
    default: "secondary"
  },
  variant: {
    type: String,
    default: "outline"
  },
  size: {
    type: String,
    default: "md"
  },
  type: {
    type: String,
    default: "button"
  },
  customClass: {
    type: String,
    default: "rounded-pill p-2 px-3 bg-gray-300 my-2"
  },
  fallbackRoute: {
    type: String,
    default: "/"
  }
});

const router = useRouter();

const handleGoBack = () => {
  // Check if there's history to go back to
  if (window.history.length > 1) {
    router.go(-1);
  } else {
    // Fallback to specified route if no history
    router.push(props.fallbackRoute);
  }
};
</script>

